import { exists } from '@/api'

export interface SystemOperationMenu {
  id: number
  name: string
  closingDay: number
  patrolDay: number
  scheduledReturnDateSlide: number
  lendAndUserCheck: number
  lendAndReturnConditions: number
  reservationConditions: number
  setVolume: number
  reservationGroup: number
  shelfTypeConversionInfo: number
  lendCountConfirmation: number
  authorDelete: number
  synonymSetting: number
  separateDictionarySetting: number
  newArrivalMagazineMailSetting: number
  code: number
  config: number
  systemCheck: number
  traderAndDonor: number
  loginUser: number
  notice: number
  budgetManagement: number
  returnHistorySearch: number
  referenceImage: number
  revision: number
}

export const defaultSystemOperationMenu = (): SystemOperationMenu => ({
  id: 0,
  name: '',
  closingDay: 0,
  patrolDay: 0,
  scheduledReturnDateSlide: 0,
  lendAndUserCheck: 0,
  lendAndReturnConditions: 0,
  reservationConditions: 0,
  setVolume: 0,
  reservationGroup: 0,
  shelfTypeConversionInfo: 0,
  lendCountConfirmation: 0,
  authorDelete: 0,
  synonymSetting: 0,
  separateDictionarySetting: 0,
  newArrivalMagazineMailSetting: 0,
  code: 0,
  config: 0,
  systemCheck: 0,
  traderAndDonor: 0,
  loginUser: 0,
  notice: 0,
  budgetManagement: 0,
  returnHistorySearch: 0,
  referenceImage: 0,
  revision: 0
})

export function SystemOperationMenuFromJSON(json: any): SystemOperationMenu {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    closingDay: exists(json, 'closing_day') ? json.closing_day : 0,
    patrolDay: exists(json, 'patrol_day') ? json.patrol_day : 0,
    scheduledReturnDateSlide: exists(json, 'scheduled_return_date_slide')
      ? json.scheduled_return_date_slide
      : 0,
    lendAndUserCheck: exists(json, 'lend_and_user_check')
      ? json.lend_and_user_check
      : 0,
    lendAndReturnConditions: exists(json, 'lend_and_return_conditions')
      ? json.lend_and_return_conditions
      : 0,
    reservationConditions: exists(json, 'reservation_conditions')
      ? json.reservation_conditions
      : 0,
    setVolume: exists(json, 'set_volume') ? json.set_volume : 0,
    reservationGroup: exists(json, 'reservation_group')
      ? json.reservation_group
      : 0,
    shelfTypeConversionInfo: exists(json, 'shelf_type_conversion_info')
      ? json.shelf_type_conversion_info
      : 0,
    lendCountConfirmation: exists(json, 'lend_count_confirmation')
      ? json.lend_count_confirmation
      : 0,
    authorDelete: exists(json, 'author_delete') ? json.author_delete : 0,
    synonymSetting: exists(json, 'synonym_setting') ? json.synonym_setting : 0,
    separateDictionarySetting: exists(json, 'separate_dictionary_setting')
      ? json.separate_dictionary_setting
      : 0,
    newArrivalMagazineMailSetting: exists(
      json,
      'new_arrival_magazine_mail_setting'
    )
      ? json.new_arrival_magazine_mail_setting
      : 0,
    code: exists(json, 'code') ? json.code : 0,
    config: exists(json, 'config') ? json.config : 0,
    systemCheck: exists(json, 'system_check') ? json.system_check : 0,
    traderAndDonor: exists(json, 'trader_and_donor')
      ? json.trader_and_donor
      : 0,
    loginUser: exists(json, 'login_user') ? json.login_user : 0,
    notice: exists(json, 'notice') ? json.notice : 0,
    budgetManagement: exists(json, 'budget_management')
      ? json.budget_management
      : 0,
    returnHistorySearch: exists(json, 'return_history_search')
      ? json.return_history_search
      : 0,
    referenceImage: exists(json, 'reference_image') ? json.reference_image : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
